module.exports = __webpack_public_path__ + "img/g2s-logo.36edcaac.svg";